// @ts-nocheck
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
// material
import {
  Stack,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  FormControl,
  RadioGroup,
  FormLabel,
  Radio,
  Box,
  FormHelperText
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// component
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const LoginSchema = Yup.object().shape({
  username: Yup.string().email('Email must be a valid email').required('Email is required'),
  password: Yup.string().required('Password is required'),
});

export default function LoginForm({ showPassword, handleShowPassword, handleLogin, isLoading }) {
  return (
    <Formik
      initialValues={{ username: '', password: '', remember: false, categoryType: 'UTSA' }}
      validationSchema={LoginSchema}
      onSubmit={(values) => {
        const payload = {
          username: values.username.toLowerCase(),
          password: values.password,
          remember: values.remember,
          category: values.categoryType,
        };
        handleLogin(payload);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        /* and other goodies */
      }) => (
        <Box>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <FormControl sx={{ mb: 2 }}>
                <FormLabel id="demo-row-radio-buttons-group-label"> Sign in as</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="categoryType"
                  value={values.categoryType.toString()}
                  onChange={(event) => {
                    setFieldValue('categoryType', event.target.value);
                  }}
                  error={`${!!(touched.categoryType && errors.categoryType)}`}
                >
                  <FormControlLabel id="UTSA" value="UTSA" control={<Radio />} label="Admin" />
                  <FormControlLabel id="UTSP" value="UTSP" control={<Radio />} label="Vendor" />
                  <FormControlLabel id="UTLB" value="UTLB" control={<Radio />} label="Driver" />
                </RadioGroup>
                {!!(touched.categoryType && errors.categoryType) && <FormHelperText>{errors.categoryType}</FormHelperText>}

              </FormControl>
              <TextField
                fullWidth
                type="email"
                name="username"
                label="Email address"
                value={values.username}
                onChange={handleChange}
                onBlur={handleBlur}
                error={Boolean(touched.username && errors.username)}
                helperText={touched.username && errors.username}
              />

              <TextField
                fullWidth
                type={showPassword ? 'text' : 'password'}
                label="Password"
                name="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleShowPassword} edge="end">
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={Boolean(touched.password && errors.password)}
                helperText={touched.password && errors.password}
              />
            </Stack>

            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
              {/* <FormControlLabel
              control={
                <Checkbox name={'remember'} onChange={handleChange} onBlur={handleBlur} checked={values.remember} />
              }
              label="Remember me"
            />

            <Link component={RouterLink} variant="subtitle2" to="#" underline="hover">
              Forgot password?
            </Link> */}
            </Stack>

            <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isLoading} style={{color:'white',
                backgroundColor:'#E23744',}}>
              Login
            </LoadingButton>
          </Form>
        </Box>
      )}
    </Formik>
  );
}
